module.exports = __webpack_public_path__ + "img/pic-WanfengChen.96f82cfb.png";